import { Pipe, PipeTransform } from '@angular/core';
/**
 * return class-able string, separated by space
 * @param data: string | array | complex array of string
 * ex: 'class name' => 'class-name'
 *     ['Class 1', 'Class 2'] => 'class-1 class-2']
 *     ['Class 1', ['Class 21', 'Class 22']] => 'class-1 class-21 class22']
 */
@Pipe({
  name: 'toClass',
  standalone: false,
})
export class ToClassPipe implements PipeTransform {
  transform(data: string | any[]): string {
    if (Array.isArray(data)) {
      return data.map(element => this.transform(element)).join(' ');
    }

    if (typeof data === 'string') {
      return this.stringToClassName(data);
    }

    return '';
  }

  private stringToClassName(str) {
    return str
      .toLowerCase()
      .split(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/\s]/)
      .filter(v => v.match(/[a-z0-9]/))
      .join('-')
      .trim();
  }
}
